import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, ClockIcon, FrownIcon } from 'lucide-react';
const problems = [{
  icon: ClockIcon,
  title: 'Te sientas a estudiar',
  description: 'Abres el material. Sientes 2% de incomodidad (tarea difícil, aburrimiento, ansiedad). "Solo checo un segundo."'
}, {
  icon: AlertCircleIcon,
  title: 'Se fue una hora. Dos. Tres.',
  description: 'Ahora estás tarde, cansado/a, y con culpa.'
}, {
  icon: FrownIcon,
  title: 'Y entonces haces lo que casi todos hacen',
  description: 'Intentas arreglarlo con fuerza de voluntad. Y dura… ¿cuánto? Un día bueno. A veces medio día.'
}];
export function ProblemSection() {
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-185">
      <div className="max-w-6xl mx-auto" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-187">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mb-6" data-id="element-188">
            Esto probablemente te está pasando{' '}
            <span className="text-teal" data-id="element-189">(y te da rabia admitirlo)</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-190">
          {problems.map((problem, index) => {
          const Icon = problem.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2,
            duration: 0.6
          }} className="bg-gray-50 rounded-xl p-8 border-2 border-gray-200 hover:border-teal transition-colors duration-300" data-id="element-191">
                <div className="bg-teal/10 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-192">
                  <Icon className="w-8 h-8 text-teal" aria-hidden="true" data-id="element-193" />
                </div>
                <h3 className="text-xl font-bold text-navy mb-4" data-id="element-194">
                  {problem.title}
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-195">
                  {problem.description}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8,
        duration: 0.6
      }} className="mt-16 text-center" data-id="element-196">
          <p className="text-2xl font-semibold text-navy-light" data-id="element-197">
            Hasta que llega un día pesado y tu cerebro hace{' '}
            <span className="text-teal font-bold" data-id="element-198">lo que ya aprendió.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}